<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [style]="{ width: '40vw' }"
  [draggable]="false"
  [resizable]="false"
  (onHide)="onHide()"
  [header]="config?.header || 'Confirmation'"
>
  <div class="confirmation-content" *ngIf="config">
    <i *ngIf="config.icon" [class]="config.icon" style="font-size: 2rem; margin-right: 1rem;"></i>
    <p>{{ config.message }}</p>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      *ngIf="config?.rejectButtonLabel"
      [label]="config!.rejectButtonLabel!"
      [styleClass]="config!.rejectButtonStyleClass || 'p-button-secondary p-button-text'"
      (click)="onReject()"
    ></p-button>
    <p-button
      [label]="config?.acceptButtonLabel || 'Confirm'"
      [styleClass]="config!.acceptButtonStyleClass || 'p-button-primary'"
      (click)="onAccept()"
    ></p-button>
  </ng-template>
</p-dialog>